import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
// import Logo from '../../assets/images/Desktop.png'
import NavbarLogo from '../../assets/images/logo.png';
import WOW from 'wowjs';
import { useTranslation } from 'react-i18next';

const locales = {
  en: { title: 'English' },
  fr: { title: 'French'},
  ar: { title: 'Arabic'}
}

const Navbar = ({languageChangeDetection}) => {
  const { t, i18n} = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState(
    (i18n.language || 'ar').substring(0, 2)
  );
  const [langOpen, setLangOpen] = useState(false);

  useEffect(() => {
    const lang = i18n.language || 'en';
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [i18n.language]);

  useEffect(() => {
    const handleOutside = (e) => {
      if (!e.target.closest('.nav-lang-dropdown')) setLangOpen(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  const location = useLocation()
  const path = location.pathname
  const [sticky, setSticky] = useState(false)
  const [menu, setmenu] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

  const handleLanguageChange = (language) => {
      setSelectedLanguage(language);
      languageChangeDetection(language);
      i18n.changeLanguage(language);
      document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = language;
  };

  const activeMenu = () => {
    if (path === "/" || path === "/home-02" || path === "/home-03") {
      setmenu({ home: true })
    } else if (path === "/about" || path === "/team") {
      setmenu({ pages: true })
    } else if (path === "/service-01" || path === "/service-02" || path === "qa-testing" || path === "/it-management" || path === "cyber-security" || path === "/it-consultant" || path === "/infrastructure-plan") {
      setmenu({ services: true })
    } else if (path === "/projects" || path === "/project-details") {
      setmenu({ project: true })
    } else if (path === "/blog" || path === "/blog-details") {
      setmenu({ blog: true })
    } else if (path === "/contact") {
      setmenu({ contact: true })
    } else {
      setmenu({ home: true })
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.scroll(0, 0);
    new WOW.WOW({ live: false }).init();
    activeMenu();
  }, [path]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleWindowResize = () => {
      const w = window.innerWidth;
      setIsMobile(w < 1200);
      if (w >= 1200) setMenuOpen(false);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const closeMenu = () => setMenuOpen(false);
  const isSticky = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 50 ? setSticky(true) : setSticky(false);
  }

  const navigate = () => {
    window.open("https://calendly.com/codecraftcorp", "_blank");
  } 
  return (
    <>
      <div className="topbar">
        <div className="container-fluid">
          <ul className="topbar__info">
            <li>
              <i className="fa fa-envelope"></i>
              <Link to="mailto:info@codecraftcorp.org">info@codecraftcorp.org</Link>
            </li>
            <li>
              <i className="fa fa-map-marker"></i>
              {t('nav_bar.add_detail')}
            </li>
          </ul>
          <ul className="topbar__social">
            {/* Social media icons hidden */}
          </ul>
        </div>
      </div>
      <nav
        className={`main-menu sticky-header${sticky ? " sticky-header--cloned sticky-fixed" : ""}${menuOpen ? " menu-open" : ""}`}
      >
        <div className="container-fluid">
          <div className="main-menu__logo">
          {/*  <Link to="/">
              <img src={Logo} width="100" height="43"  alt="codecraftcorp" />
            </Link> */}

      {/* <Link to="/" style={{
        fontFamily: "'Roboto', 'Montserrat', sans-serif",
        fontSize: "25px",
        fontWeight: "500",
        color: "#1e40af",
        textDecoration: "none",
        letterSpacing: "2.5px",
        display: "inline-block",
        padding: "12px 0",
        textTransform: "uppercase"
      }}>
        CODE CRAFT
      </Link> */}

      <Link to="/" style={{
  display: "flex",
  alignItems: "center",
  height: "100%"
}}>
  <img 
    src={NavbarLogo} 
    alt="Code Craft" 
    style={{
      height: "60px",  // Change this value to increase/decrease logo size
      width: "auto",
      objectFit: "contain",
      maxHeight: "100%"
    }}
  />
</Link>

          </div>
          <ul
            className="main-menu__list"
            style={isMobile ? { display: menuOpen ? 'block' : 'none' } : undefined}
          >
              <li
                className={`menu-item-has-children ${menu.home && "current"}`}
              >
                <Link to="/" onClick={closeMenu}>
                {t('nav_bar.home')}
                </Link>
              </li>
              <li
                className={`menu-item-has-children ${menu.pages && "current"}`}
              >
                <Link to="/about" onClick={closeMenu}>
                {t('nav_bar.about_us')}
                </Link>
                {/* <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/team">Our Team</Link>
                  </li>
                </ul> */}
              </li>
              <li
                className={`menu-item-has-children ${
                  menu.services && "current"
                }`}
              >
                <Link to="/services">{t('nav_bar.services')}</Link>
                <ul>
                  {/* <li>
                    <Link to="/service-01">Services 01</Link>
                  </li>
                  <li>
                    <Link to="/service-02">Services 02</Link>
                  </li> */}
                  <li>
                    <Link to="">{t('nav_bar.it_and_development')}</Link>
                    <ul>
                      <li>
                        <Link onClick={closeMenu} to="/Webapp">
                        {t('nav_bar.web_application')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/mobileapp">
                        {t('nav_bar.mobile_app')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/frontend">
                        {t('nav_bar.frontend_development')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Clouddev">
                        {t('nav_bar.cloud_devOps')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Chatbot">
                        {t('nav_bar.chatbot_development')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Bigdata">
                        {t('nav_bar.big_data')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/qa-testing">
                        {t('nav_bar.qa_testing')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Cloudintegration">
                        {t('nav_bar.cloud_integration')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/ITmerit">
                        {t('nav_bar.it_metrics_and_dashboard')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/cyber-security">
                        {t('nav_bar.cyber_security')}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/it-consultant">
                      {t('nav_bar.it_consultant')}
                      </Link>
                    <ul>
                      <li>
                        <Link onClick={closeMenu} to="/hireing">
                          {t('nav_bar.hire_development')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/microsoftenterprise">
                        {t('nav_bar.microsoft')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Iot">
                        {t('nav_bar.iot')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Ar">
                        {t('nav_bar.ar_vr')}
                        </Link>
                      </li>
                      {/* <li>
                        <Link onClick={closeMenu} to="/Business">
                        {t('nav_bar.business_technology')}
                        </Link>
                      </li> */}
                      <li>
                        <Link onClick={closeMenu} to="/ProductPrototype">
                        {t('nav_bar.product_prototype')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/ManagedServices">
                        {t('nav_bar.managed_services')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Enterprice">
                        {t('nav_bar.enterprise_mobility')}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/">
                      {t('nav_bar.processes')}
                      </Link>
                    <ul>
                      <li>
                        <Link onClick={closeMenu} to="/DevelopMethodology">
                        {t('nav_bar.development_methodology')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Delivery">
                        {t('nav_bar.delivery_models')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={closeMenu} to="/Pricing">
                          {t('nav_bar.pricing_models')}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  {/* <li>
                  <Link to="/it-management">IT Management</Link>
                </li>
                <li>
                  <Link to="/infrastructure-plan">Infrastructure Plan</Link>
                </li> */}
                </ul>
              </li>

              <li
                className={`menu-item-has-children ${
                  menu.services && "current"
                }`}
              >
                <Link to="/">
                  {t('nav_bar.industries')}
                  </Link>
                <ul>
        
                  <li>
                    <Link onClick={closeMenu} to="/Healthcare">
                    {t('nav_bar.healthcare')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Education">
                    {t('nav_bar.education_e_learning')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Social">
                    {t('nav_bar.social_network')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Retail">
                    {t('nav_bar.retail')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Manufactur">
                    {t('nav_bar.manufactring')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Ecommerce">
                    {t('nav_bar.e_commerce')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Energy">
                    {t('nav_bar.energy')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Travel">
                    {t('nav_bar.travel_hospitality')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/RealEstate">
                    {t('nav_bar.real_estate')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Media">
                    {t('nav_bar.media_entertainment')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Logistics">
                    {t('nav_bar.logistics_distribution')}
                    </Link>
                  </li>
                  <li>
                    <Link onClick={closeMenu} to="/Construction">
                    {t('nav_bar.construction')}
                    </Link>
                  </li>
                </ul>
              </li>
              {/* <li
                className={`menu-item-has-children ${
                  menu.project && "current"
                }`}
              >
                <Link to="/projects">Projects</Link>
                <ul>
                  <li>
                    <Link to="/projects">Projects</Link>
                  </li>
                  <li>
                    <Link to="/project-details">Projects Details</Link>
                  </li>
                </ul>
              </li>
              <li
                className={`menu-item-has-children ${menu.blog && "current"}`}
              >
                <Link to="/blog">Blog</Link>
                <ul>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="/blog-details">Blog Details</Link>
                  </li>
                </ul>
              </li> */}
              <li
                className={`menu-item-has-children ${
                  menu.contact && "current"
                }`}
              >
                <Link to="/contact" onClick={closeMenu}>
                {t('nav_bar.contact')}
                </Link>
              </li>
            </ul>
          <div className="main-menu__right">
            <div className="nav-lang-dropdown">
              <button
                className="nav-lang-btn"
                onClick={() => setLangOpen(!langOpen)}
              >
                {locales[selectedLanguage]?.title}
                <i className="fa fa-caret-down"></i>
              </button>
              {langOpen && (
                <div className="nav-lang-menu">
                  {Object.keys(locales).map((locale) => (
                    <button
                      key={locale}
                      className={`nav-lang-item${selectedLanguage === locale ? ' active' : ''}`}
                      onClick={() => { handleLanguageChange(locale); setLangOpen(false); }}
                    >
                      {locales[locale].title}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button
              className="mobile-nav__toggler"
              onClick={() => setMenuOpen(prev => !prev)}
              aria-label="Toggle navigation"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <Link
              to="#"
              className="search-toggler none"
            >
              <i className="icon-magnifying-glass"></i>
            </Link>
            <Link to="#" className="main-menu__cta" onClick={navigate}>
              <i className="fa fa-clock"></i>
              <span className="main-menu__cta__text">{t('nav_bar.schedule_meeting')}</span>
            </Link>
          </div>
        </div>
      </nav>
      {/* <div className={`search-popup ${search && "active"}`}>
          <div
            className="search-popup__overlay search-toggler"
            onClick={() => setSearch(false)}
          ></div>
          <div className="search-popup__content">
            <form action="#">
              <label htmlFor="search" className="sr-only">
                search here
              </label>
              <input type="text" id="search" placeholder="Search Here..." />
              <button
                type="submit"
                aria-label="search submit"
                className="thm-btn"
              >
                <span>
                  <i className="icon-magnifying-glass"></i>
                </span>
              </button>
            </form>
          </div>
        </div> */}
    </>
  );
}

export default Navbar